import {AbstractFilterComponent} from "../abstract-filter-component.js";
import {FilterLabel} from "./label.js";

export class FilterHidden extends AbstractFilterComponent {

	static selector = '.js-filter-hidden';

	label;

	getFormData(){
		let self = this;
		let data = {};

		if (self.node.value) {
			data[self.node.name] = self.node.value;
		}

		return data;
	}

	getLabel() {
		let self = this;

		if (! self.node.value) {
			return;
		}

		if (self.label) {
			return self.label;
		}

		self.label = new FilterLabel(self, self.node.dataset.label);
		return self.label;
	}

	labelDismissed() {
		let self = this;
		self.filter.setForceUpdateMode();

		self.label = null;
		self.node.value = null;

		self.componentStateChanged();
	}
}
